<template>
    <div class="close-header-title no-con">
        <section class="shop-inner-section new-home-banner">
            <div class="overlay-element">
                
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                          <h1 class="mb-4"> {{ $t('common.hero_title_prefix') }}
                           <strong>{{ $t('common.hero_title_highlight') }}</strong> {{ $t('common.hero_title_suffix') }}</h1>
                           <h4 class="mb-4">{{$t('common.hero_subtitle')}}</h4>
                    </div>
                </div>
                <div class="row m-0">
                     <div class="new-search-container d-flex shadow bg-white rounded-pill align-items-center px-4 w-100 mb-sm-2 mb-lg-5 position-relative">
                        <SearchInput :navigate-to-results="true" />
                    </div>
                </div>
                <div class="icon-boxes-wrap mt-5">
                    <div class="row">
                          <div class="col-4">
                              <div class="d-flex align-items-center mb-3 mb-sm-0 flex-nowrap" style="row-gap: 7px;">
                                  <div class="mr-3">
                                      <svg style="width: 50px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                                          <path d="M9.5 12.4L10.9286 14L14.5 10" stroke="#70d3ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          <path d="M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167C21 10.8996 21 11.4234 21 11.9914C21 14.4963 20.1632 16.4284 19 17.9041M3.19284 14C4.05026 18.2984 7.57641 20.5129 9.89856 21.5273C10.62 21.8424 10.9807 22 12 22C13.0193 22 13.38 21.8424 14.1014 21.5273C14.6796 21.2747 15.3324 20.9478 16 20.5328" stroke="#70d3ff" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                  </div>
                                  <div>
                                     <h5 class="mb-2 font-weight-bold">{{ $t('common.verified_listings') }}</h5>
                                     <p class="m-0  d-none d-sm-block">{{ $t('common.all_properties_are_checked') }}</p>
                                  </div>
                              </div>
                          </div>
                         <div class="col-4">
                              <div class="d-flex mb-3 mb-sm-0 flex-nowrap" style="row-gap: 3px;">
                                  <div class="mr-2">
                                      <svg style="width: 65px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                                          <path d="M3.5 9.398C3.5 8.37292 3.5 7.86038 3.70266 7.47025C3.87343 7.14149 4.14149 6.87343 4.47025 6.70266C4.86038 6.5 5.37292 6.5 6.398 6.5H17.602C18.6271 6.5 19.1396 6.5 19.5298 6.70266C19.8585 6.87343 20.1266 7.14149 20.2973 7.47025C20.5 7.86038 20.5 8.37292 20.5 9.398V15.602C20.5 16.6271 20.5 17.1396 20.2973 17.5298C20.1266 17.8585 19.8585 18.1266 19.5298 18.2973C19.1396 18.5 18.6271 18.5 17.602 18.5H6.398C5.37292 18.5 4.86038 18.5 4.47025 18.2973C4.14149 18.1266 3.87343 17.8585 3.70266 17.5298C3.5 17.1396 3.5 16.6271 3.5 15.602V9.398Z" stroke="#70d3ff"/>
                                          <path d="M3.5 10.5L20.5 10.5" stroke="#70d3ff" stroke-linecap="round"/>
                                          <circle cx="6.5" cy="15.5" r="0.5" fill="#70d3ff"/>
                                      </svg>
                              
                                  </div>
                                  <div>
                                      <h5 class="mb-2 font-weight-bold">{{ $t('common.zero_percent_fees') }}</h5>
                                      <p class="m-0 d-none d-sm-block">{{ $t('common.no_fees_during_your_stay') }}</p>
                                  </div>
                              </div>
                         </div>
                         <div class="col-4">
                              <div class="d-flex align-items-center mb-3 mb-sm-0 ml-2 ml-sm-0 flex-nowrap" style="row-gap: 10px;">
                                  <div class="mr-3">
                                     <svg style="width: 42px;" xmlns="http://www.w3.org/2000/svg" fill="#70d3ff" viewBox="0 0 16 16">
                                          <path d="M7.25 11.2v1.42h1.5V11.2a1.48 1.48 0 0 0 .85-1.32A1.55 1.55 0 0 0 8 8.38a1.55 1.55 0 0 0-1.6 1.5 1.48 1.48 0 0 0 .85 1.32z"/>
                                          <path d="M14.75 5H13.5A5.29 5.29 0 0 0 8 0a5.29 5.29 0 0 0-5.5 5H1.25A1.25 1.25 0 0 0 0 6.25v8.5A1.25 1.25 0 0 0 1.25 16h13.5A1.25 1.25 0 0 0 16 14.75v-8.5A1.25 1.25 0 0 0 14.75 5zM8 1.25A4.05 4.05 0 0 1 12.25 5h-8.5A4.05 4.05 0 0 1 8 1.25zm6.75 13.5H1.25v-8.5h13.5z"/>
                                      </svg>
                                  </div>
                                  <div>
                                      <h5 class="mb-2 font-weight-bold">{{ $t('common.secure_payments') }}</h5>
                                      <p class="m-0 d-none d-sm-block">{{ $t('common.your_money_is_protected') }}</p>
                                  </div>
                              </div>
                         </div>                                               
                    </div>
                </div>
            </div>
        </section>
        <section class="pt_large pb_large shop-inner-section new-shop-section">
            <div class="container">
                <div class="row align-items-center pt-3 m-0">
                    <div class="col-6">
                        <div class="main-heading total-property-results">
                            <div v-if="totalRecords === 0" class="no-properties-found">
                                <span>{{ $t('property_detail.no_property_found_in_location', { location: currentCity }) }}. </span>
                                <span class="text-info">{{ $t('property_detail.recomended_properties') }}</span>  
                            </div>
                            <h1 v-else>
                            <!-- <h1> -->
                                <span v-if="isLoading" class="skeleton-text large"></span>
                                <p class="total-properties d-flex flex-nowrap" v-else-if="locationEmpty">
                                    <span class="property-label w-auto mr-3 mr-md-0"> Properties
                                        <!-- {{ $t('property_detail.stay_without_location', {  
                                            properties: totalRecords,
                                            location: currentCity   
                                        })
                                        }} -->
                                        </span>
                                        <span class="badge-count d-flex align-items-center justify-content-center"> {{totalRecords}}</span>
                                    <span v-if="fav">({{ $t('property_detail.favorites') }})</span>
                                </p>               
                                <p v-else>  
                                    <span v-if="totalRecords==1">{{ $t('property_detail.stay_single_property', { properties: totalRecords, location: currentCity })}}</span>
                                    <span v-else-if="totalRecords > 1">{{ $t('property_detail.stay', { properties: totalRecords, location: currentCity })}}</span>
                                    <span v-if="fav">({{ $t('property_detail.favorites') }})</span>
                                </p>
                            </h1>
                        </div>
                    </div>
                    <div class="col-6 text-right mb-4">
                        <button
                                v-b-modal.modal-1
                                :class="[
                                    'filter-btn border-0 p-3 px-3 shadow-sm rounded-sm rounded-pill',
                                    activeFilterCount ? 'filter-active' : 'bg-transparent'
                                ]"
                                type="button"
                            >
                            <div class="flex gap-x-xs">
                                <i class="fa fa-sliders d-none d-sm-inline-flex"></i>
                                <span class="text-n font-medium font-weight-bold leading-none ml-0 ml-sm-2 mr-1 lg:hidden">
                                    {{ $t('property_detail.More_filters') }}
                                </span>
                                <i class="fa fa-angle-down"></i><span
                                v-if="activeFilterCount"
                                class="filter-count"
                                    >
                                {{ activeFilterCount }}
                            </span>
                            </div>
                        </button>
                    </div>
                    
                    <template v-if="isLoading">
                        <div class="box-column px-2" v-for="index in 10" :key="'skeleton-' + index">
                            <div class="top-partner-item skeleton-card d-flex flex-nowrap d-sm-block">
                                <div>
                                   <div class="skeleton-img"></div>
                                </div>
                                <div>
                                 <div class="skeleton-text"></div>
                                 <div class="skeleton-text small"></div>
                                </div>
                               
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="box-column px-2" v-for="(property, index) in displayedProperties" :key="index">
                            <div class="top-partner-item top-partners__item buscont shadow-sm border-0  flex-nowrap d-flex d-sm-block">
                                <div class="imgdet cursor-pointer position-relative">
                                    <div @click="propertyDetail(property.id)">
                                        <b-carousel id="carousel-1" v-model="slide[index]" :interval="0" controls
                                            indicators background="#ababab" img-width="1024" img-height="480"
                                            style="text-shadow: 1px 1px 2px #333;" @sliding-start="onSlideStart(index)"
                                            @sliding-end="onSlideEnd(index)">

                                            <b-carousel-slide v-for="(photo, index) in property.photos" :key="index"
                                                :img-src="photo.path">
                                            </b-carousel-slide>
                                        </b-carousel>
                                      
                                    </div>
                                      <div class="add-to-favorite shadow bg-white rounded-circle position-absolute top-0 right-0 justify-content-center d-flex align-items-center">
                                                <button v-b-tooltip.hover :title="$t('property_detail.add_favourite')"
                                                        class="heart-btn new-heart-btn" @click="addFavourite(property.id)">
                                                        <i :class="[isFavorited(property) ? 'fas fa-heart' : 'far fa-heart']"
                                                            aria-hidden="true" style="font-size: 20px;"></i> 
                                                </button>
                                        </div>
                                    <!-- <div class="favorite-button-discount" v-if="property.discount_on_long_stay === 'yes'">
                                    <span class="checked-span">-{{ property.onemonthdis }}% OFF</span>
                                </div>
                                <div class="favorite-button-discount" v-if="property.discountpersentage != null">
                                    <span class="checked-span">-{{ property.discountpersentage }}% OFF</span>
                                </div> -->
                                    <div class="favorite-button-discount"
                                        v-if="property.flash_discount_applied === 'yes'">
                                        <span class="checked-span">{{ $t('property_detail.flash_discount') }} <span
                                                class="minus-discount-ic">-</span><strong>{{
                                                    property.flash_discount_percentage }}</strong>% </span>
                                    </div>

                                    <div class="favorite-button-discount"
                                        v-if="property.discount_on_long_stay === 'yes' && property.flash_discount_applied !== 'yes'">
                                        <span class="checked-span month-discounts"><span
                                                class="minus-discount-ic">-</span><strong>{{ property.onemonthdis
                                                }}</strong>% </span>
                                    </div>

                                    <!-- This will show the general discount percentage, if applicable, only if there is no flash discount -->
                                    <div class="favorite-button-discount"
                                        v-if="property.discountpersentage != null && property.flash_discount_applied !== 'yes'">
                                        <span class="checked-span"><span class="minus-discount-ic">-</span><strong>{{
                                            property.discountpersentage }}</strong>% </span>
                                    </div>


                                    <!-- <div class="favorite-button">
                                    <button class="heart-btn" @click="addFavourite(property.id)">
                                        <i :class="[isFavorited(property) ? 'fa-regular fa-star' : 'fa-solid fa-star']"
                                            aria-hidden="true"></i>
                                           
                                    </button>
                                </div> -->
                                </div>
                                <div class="imgdet">
                                    <div class="d-flex flex-column position-static card-discription" @click="propertyDetail(property.id)">
                                        <div class="d-flex align-items-center justify-content-between"
                                            >
                                            <div>

                                                <div v-if="property.rating && property.rating.length >= 0"
                                                    class="d-flex rating-starts">
                                                    <!-- <div class="rating-counter">
                                                        <span>{{ calculateAverageRating(property.rating) }}</span>
                                                    </div> -->
                                                    <!-- <span class="reviews-expretion">Good</span>     -->
                                                    <!-- <span v-if="property.rating">{{
                                                    getReviewFeedback(calculateAverageRating(property.rating)) }}</span> -->

                                                    <!-- <span class="reviews-expression" v-if="property.rating"> ({{
                                                        property.rating.length }} {{ $t('property_detail.reviews')
                                                        }})</span>
                                                    <span class="reviews-text"></span> -->
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-end w-full">
                                                <!-- <button v-b-tooltip.hover :title="$t('property_detail.add_favourite')"
                                                    class="heart-btn new-heart-btn" @click="addFavourite(property.id)">
                                                    <i :class="[isFavorited(property) ? 'fas fa-star' : 'far fa-star']"
                                                        aria-hidden="true" style="font-size: 16px;"></i> 
                                                </button> -->
                                            </div>
                                        </div>
                                        <!-- <p class="mb-auto buz-name">{{ $t('property_detail.' + property.property_type) }}
                                    </p> -->
                                     <div class="detail-text d-flex">
                                            <div class="content-col">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="none">
                                                    <path fill="#676767"
                                                        d="M8 1C5.236 1 3 3.191 3 5.9 3 9.575 8 15 8 15s5-5.425 5-9.1C13 3.191 10.764 1 8 1M4.429 5.9c0-1.932 1.6-3.5 3.571-3.5s3.571 1.568 3.571 3.5c0 2.016-2.057 5.033-3.571 6.916C6.514 10.947 4.429 7.895 4.429 5.9">
                                                    </path>
                                                    <path fill="#676767"
                                                        d="M8 7.65c.986 0 1.786-.784 1.786-1.75S8.986 4.15 8 4.15s-1.786.784-1.786 1.75.8 1.75 1.786 1.75">
                                                    </path>
                                                </svg>
                                            </div>
                                            <p class="card-text"><span class="ml-0">{{ formatLocation(property) }}</span>
                                            </p>
                                        </div>
                                        <div class="mt-3">
                                            <p class="mb-auto buz-name">
                                                <!-- {{ property.accommodation_type }} -->
                                                {{ $t('property_detail.accommodation_types.' + property.accommodation_type) }}
                                            </p>
                                        </div>
                                       
                                        <!-- <p class="mb-2 card-text"><span> </span></p> -->
                                        <div class="font-semibold text-n"
                                            v-if="property.discount_on_long_stay === 'yes'">
                                            <!-- <span>Discounts on Long Stays</span> -->
                                        </div>
                                        <div v-else-if="property.discountedPrice != null"
                                            class="font-semibold text-n strikethrough box-footer"
                                            data-cy="currency-quantile"
                                            style="margin-bottom: 0px;position: absolute;bottom: 48px;">
                                            <span class="text-xlightgrey">
                                                {{ currency }}</span>
                                            <span class="strikethrough">{{ property.formattedPrice }} {{
                                                property.discountedPrice }}</span><span class=" "> /
                                            </span><span class="">{{ $t('property_detail.night') }}</span>
                                        </div>
                                        <div class="box-footer">
                                            <div class="gap-y-xs mb-0 mb-sm-3">
                                                <div class="relative d-flex items-center gap-1 price whitespace-nowrap">
                                                     <div class="font-semibold text-n" data-cy="currency-quantile"><span
                                                             class="brand-color">
                                                             {{ currency }}</span><span class="brand-color"> {{
                                                                 property.price_per_month || property.formattedPrice || property.price }}</span><span
                                                             class=" "> /
                                                         </span><span class="">{{ property.price_per_month ?
                                                             $t('property_detail.month') : $t('property_detail.night')
                                                             }}</span></div>
                                                    <br>
                                                    <!-- <span class="tadd-date">Add dates</span> -->
                                                </div>
                                            </div>
                                            <!-- <div class="d-flex align-items-center" v-if="property.rating && property.rating.length > 0">
                                            <i class="fas fa-star" aria-hidden="true" style="color: #F2C90C;"></i>
                                            <span class="reviews-expression ml-1" v-if="property.rating">{{ calculateAverageRating(property.rating) }}</span>
                                          </div> -->
                                            <a class="card-blue-btn w-100 rounded p-3 new-button d-none d-sm-flex" type="button" style="max-width: none;" data-cy="card-view-btn"
                                                @click="propertyDetail(property.id)">
                                                {{ $t('property_detail.View') }} 
                                                <svg style="width: 20px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                                                    <path d="M566.6 342.6C579.1 330.1 579.1 309.8 566.6 297.3L406.6 137.3C394.1 124.8 373.8 124.8 361.3 137.3C348.8 149.8 348.8 170.1 361.3 182.6L466.7 288L96 288C78.3 288 64 302.3 64 320C64 337.7 78.3 352 96 352L466.7 352L361.3 457.4C348.8 469.9 348.8 490.2 361.3 502.7C373.8 515.2 394.1 515.2 406.6 502.7L566.6 342.7z"/>
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="row " v-if="!displayedProperties">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                        <div class="card left-card listing-bg-box" style="background: #a9a5a5 !important">
                            <div class="card-header" style="display:none"></div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <h5 class="text-black text-center">{{ $t('property_detail.no_properties_found')
                                            }}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer" style="display:none">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div v-if="displayedProperties.length < totalRecords" class="load-more-trigger"
                    @mouseover="handleMouseOver" ref="loadMoreTrigger" style="padding: 50px;">
                </div> -->
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <!-- <button v-if="next_page != null" @click="loadMore" class="btn btn-primary">
                            {{ $t('property_detail.view_more') }}
                        </button> -->
                        <button v-if="!isLoading && isLoaded && next_page" @click="loadMore" class="btn btn-primary">
                            {{ $t('property_detail.view_more') }}
                        </button>

                    </div>
                </div>
            </div>
        </section>
        <b-modal id="modal-xl" size="xl" :title="$t('property_detail.stays_in_range', { count: totalRecords })"
            @shown="handleModalShown">
            <div class="show-map-modal">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="row p-3">
                            <div class="col-lg-4" v-for="(property, index) in displayedProperties" :key="index">
                                <div class="top-partner-item top-partners__item buscont"
                                    @click="propertyDetail(property.id)">
                                    <div class="imgdet cursor-pointer">
                                        <div>
                                            <b-carousel id="carousel-1" v-model="slide[index]" :interval="0" controls
                                                indicators background="#ababab" img-width="1024" img-height="480"
                                                style="text-shadow: 1px 1px 2px #333;"
                                                @sliding-start="onSlideStart(index)" @sliding-end="onSlideEnd(index)">

                                                <b-carousel-slide v-for="(photo, index) in property.photos" :key="index"
                                                    :img-src="photo.path">
                                                </b-carousel-slide>
                                            </b-carousel>
                                        </div>
                                        <div class="favorite-button-discount">
                                            <span class="checked-span">{{ $t('property_detail.discounted') }}</span>
                                        </div>
                                        <div class="favorite-button">
                                            <button class="heart-btn">
                                                <i class="far fa-star" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="imgdet">
                                        <div class="d-flex flex-column position-static card-discription" @click="propertyDetail(property.id)">
                                            <div v-if="property.rating && property.rating.length > 1"
                                                class="d-flex rating-starts" style="margin-bottom: 15px;">
                                                <div class="rating-counter">
                                                    <span>{{ calculateAverageRating(property.rating) }}</span>
                                                </div>
                                                <!-- <span class="reviews-expretion">Good</span>     -->
                                                <span v-if="property.rating">{{
                                                    getReviewFeedback(calculateAverageRating(property.rating)) }}</span>

                                                <span class="reviews-expression" v-if="property.rating">({{
                                                    property.rating.length }}{{ $t('property_detail.reviews') }})</span>
                                                <span class="reviews-text"></span>
                                            </div>
                                            <p class="mb-auto buz-name">{{ $t('property_detail.' +
                                                property.property_type) }}
                                            </p>
                                            <div class="detail-text" style="margin-top: 10px;">
                                                <p class="mb-2 card-text"><span>{{ property["city"
                                                    + currentLanguage] }}, {{ property["state" + currentLanguage]
                                                        }}, {{
                                                            property["country" + currentLanguage] }}</span>
                                                </p>
                                            </div>
                                            <p class="mb-2 card-text"><span>
                                                    {{ (property.user && property.user.mobile_phone) ? property.user.mobile_phone : '' }}</span></p>
                                            <div class="d-flex box-footer">
                                                <div class="gap-y-xs">
                                                    <div
                                                        class="relative d-flex items-center gap-1 price whitespace-nowrap">
                                                         <div class="font-semibold text-n" data-cy="currency-quantile">
                                                             <span class="">{{ currency }}</span><span
                                                                 class="text-xlightgrey"> {{
                                                                     property.price_per_month || property.formattedPrice || property.price
                                                                 }}</span><span class="text-xlightgrey"> /
                                                             </span><span class="text-xlightgrey">{{ property.price_per_month ?
                                                                 $t('property_detail.month') : $t('property_detail.night')
                                                                 }}</span>
                                                         </div>
                                                        <!-- <span class="tadd-date">Add dates</span> -->
                                                    </div>
                                                </div>
                                                <a class="card-blue-btn" type="button" data-cy="card-view-btn"
                                                    @click="propertyDetail(property.id)">{{
                                                        $t('property_detail.view_detail')
                                                    }}<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em"
                                                        fill="none" viewBox="0 0 16 16">
                                                        <path fill="currentColor"
                                                            d="M12.667 12.667H3.333V3.333H8V2H3.333C2.593 2 2 2.6 2 3.333v9.334C2 13.4 2.593 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667V8h-1.333zM9.333 2v1.333h2.394L5.173 9.887l.94.94 6.554-6.554v2.394H14V2z">
                                                        </path>
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 pl-0">
                        <div class="map-sec">
                            <div ref="map" style="height: 170%;width:630px;margin-top: 4%;"></div>
                            <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11200.675829730526!2d-75.6876061!3d45.42609535!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cce04ff4fe494ef%3A0x26bb54f60c29f6e!2sParliament+Hill!5e0!3m2!1sen!2sca!4v1528808935681" frameborder="0" style="border:0" allowfullscreen></iframe> -->
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import API from '@/api';
import axios from 'axios';
import Vue from 'vue';
import _ from 'lodash';
import SearchInput from '@/components/SearchInput.vue';

import { Loader } from '@googlemaps/js-api-loader';
export default {
    name: 'home',
    components: {
        SearchInput
    },
    data() {
        return {
            fav: false,
            totalRecords: '',
            locationEmpty: true,
            city: '',
            country: '',
            regionName: '',
            slide: [],
            sliding: null,
            properties: [],
            baseUrl: '',
            headers: '',
            userdata: '',
            user_id: '',
            lat: null,
            long: null,
            search_business: null,
            miles: '',
            page: 1,
            next_page: '',
            currentType: 'all',
            filterCheck: false,
            searchWord: '',
            searchList: [],
            showBanner: false,
            currentLanguage: '',
            map: null,
            address: '',
            sortOrder: 'low-to-high',
            isDisabledProperties: [],
            currency: '',
            displayedProperties: [],
            initialLoad: 30,
            isLoading: true,
            isOneMonthOrMore: false,
            isLoaded: false,
            searchedLocations: '',
            loadingDefaultResults: false,
            hasActiveFilters: false,
            activeFilterCount: 0,
        }
    },
    beforeDestroy() {
        this.$root.$off('load-items');
        this.$root.$off('load-items-unified');
        this.$root.$off('search-initiated');
        Vue.prototype.$EventBus.$off('clear-dates');
        Vue.prototype.$EventBus.$off('changeLanguage', this.onLanguageChanged);
        this.$root.$off('load-items1');
        this.$root.$off('load-items2');
        this.$root.$off('load-items3');
        this.$root.$off('load-items4');
        this.$root.$off('load-items5');
        this.$root.$off('load-items6');
        this.$root.$off('load-items7');
        this.$root.$off('load-items8');
        this.$root.$off('load-items10');
        this.$root.$off('load-items11');
        this.$root.$off('load-items12');
        this.$root.$off('load-items13');
        this.$root.$off('load-items14');
        this.$root.$off('load-items15');
        this.$root.$off('load-items16');
        this.$root.$off('load-items17');
        Vue.prototype.$EventBus.$off('changeLanguage', this.onLanguageChanged);
    },
    computed: {
        currentCity() {
            console.log('Computing currentCity with city:', this.searchedLocations);
            console.log('Computing currentCity with city:', this.city);
        
            return this.searchedLocations;

            // if (!this.city) {    
            //     console.log('City is empty, checking localStorage for last searched location',this.city);
            //     return this.city;
            // } else {
            //     let lastSearchedLocation = localStorage.getItem('lastSearchedLocation');
            //     if (lastSearchedLocation) {
            //         let locationParts = lastSearchedLocation.split(',');
            //         return locationParts[0];
            //     }
            //     return '';
            // }

            //   if (!this.city) {
            //     console.log('City is empty, checking localStorage for last searched location',this.city);
            //         return this.city;
            //     } else {
            //         let lastSearchedLocation = localStorage.getItem('lastSearchedLocation');
            //         if (lastSearchedLocation) {
            //             let locationParts = lastSearchedLocation.split(',');
            //             return locationParts[0];
            //         }
            //         return '';
            //     }
        }
    },
    activeFilterCount() {
    let count = 0;

    if (this.city) count++;
    if (this.country) count++;
    if (this.state) count++;

    if (this.startdate || this.enddate) count++;

    if (this.guests) count++;

    if (this.type) count++;

    if (this.min || this.max) count++;

    if (this.kit) count++;
    if (this.wifi) count++;
    if (this.tv) count++;

    if (this.bed) count++;
    if (this.bath) count++;

    if (this.child) count++;
    if (this.pet) count++;

    if (this.dic) count++;

    if (this.propertyType) count++;

    if (this.targetAudience) count++;

    if (this.searchText) count++;

    if (this.ratingRange) count++;

    return count;
},
    mounted() {


        let isClearDates = false;
        Vue.prototype.$EventBus.$on('clear-dates', () => {
            console.log('Received clear-dates event');
            isClearDates = true;
            // this.loadItems();
        });
        
        // SINGLE listener on $root only - avoid duplicate calls
        this.$root.$on('load-items-unified', (payload) => {
            console.log('=== load-items-unified received in Home.vue ===', payload);
            this.loadItems(
                payload.city,
                payload.country,
                payload.state,
                payload.startdate,
                payload.enddate,
                payload.guests,
                payload.type,
                payload.min,
                payload.max,
                payload.kit,
                payload.wifi,
                payload.tv,
                payload.bed,
                payload.bath,
                payload.fav,
                payload.child,
                payload.pet,
                payload.dic,
                payload.propertyType,
                payload.targetAudience,
                payload.searchText,
                payload.currency,
                payload.ratingRange
            );
        });
        this.$root.$on('load-items', (city, country, sdate, edate) => {
            console.log('city is', city);
            console.log('country is', country);
            let searches = JSON.parse(localStorage.getItem("recentSearches")) || [];
            searches = searches.filter(s => s.city !== city || s.county !== country);
            searches.push({ city: city, county: country });
            if (searches.length > 4) {
                searches.shift();
            }
            localStorage.setItem("recentSearches", JSON.stringify(searches));
            this.$nextTick(() => {
                this.seen = true;
                let element = document.querySelector('.bottom-head');
                if (element) {
                    element.classList.remove('hidden_filter');
                }
            });
            let searchButton = document.querySelector('.search-button');
            if (searchButton) {
                searchButton.classList.remove('hidden_filter');
            }
            let mainBarElement = document.getElementById('main_bar');
            if (mainBarElement) {
                mainBarElement.classList.add('hidden_filter');
            }
            if (isClearDates) {
                this.loadItems('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '');
                isClearDates = false;
            } else {
                this.loadItems(city, country, '', sdate, edate, '', '', '', '', '', '', '', '', '', '', '', '', '', '');
            }
        });
        this.$root.$on('load-items6', (city, country, state, startdate, enddate, quantity, type, min, max, kit, wifi, tv, bed, bath, fav, childQuantity, petQuantity, dic, propertyType, targetAudience, searchText, currency = null) => {
            this.loadItems('', '', '', '', '', quantity, '', '', '', '', '', '', '', '', '', childQuantity, petQuantity, '', '', '', '', '');
        });
        this.$root.$on('load-items1', (type) => {
            console.log('loadItems1 Trigger');
            if (type == 'All Types') {
                // this.loadItems('', '', '', '', '', '', '', '', '', '');
                this.loadItems(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
            } else {
                // this.loadItems('', '', '', '', '', '', type, '', '', '');
                this.loadItems(
                    null, null, null, null, null, null, type, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null
                );
            }

        });
        this.$root.$on('load-items2', (sdate, edate, quantity, child, pet, min, max, bed, bath, propertyType) => {
            console.log('loadItems2 Trigger');
            this.loadItems('', '', '', sdate, edate, quantity, '', min, max, '', '', '', bed, bath, '', '', child, pet, propertyType);
        });
        this.$root.$on('load-items10', (cur) => {
            console.log('load-items10 Trigger');
            this.loadItems('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', cur);
        });
        this.$root.$on('load-items3', (fav) => {
            console.log('loadItems3 Trigger');
            if (fav) {
                this.fav = true;
            } else {
                this.fav = false;
            }
            this.loadItems('', '', '', '', '', '', '', '', '', '', '', '', '', '', fav);
        });
        this.$root.$on('load-items4', (range) => {
            console.log('loadItems4 Trigger');
            this.sortByRating(range);
        });

        this.$root.$on('load-items5', (range) => {
            console.log('loadItems5 Trigger');
            let order = '';
            if (range === 'low-to-high') {
                order = 'asc';
            } else if (range === 'high-to-low') {
                order = 'desc';
            }
            this.sortByPrice(order);
        });
        this.$root.$on('load-items7', (city, state, country, sdate, edate, quantity, child, pet, bed, bath, minPrice, maxPrice, propertyType) => {
            console.log('loadItems7 Trigger');
            this.loadItems(city, country, state, sdate, edate, quantity, '', minPrice, maxPrice, '', '', '', bed, bath, '', child, pet, propertyType);
        });
        this.$root.$on('load-items8', (sdate, edate, quantity, bed, bath, min, max, child, pet, propertyType) => {
            console.log('loadItems8 Trigger');
            console.log("Pet Quantity:", pet);
            this.loadItems('', '', '', sdate, edate, quantity, '', min, max, '', '', '', bed, bath, '', '', child, pet, propertyType);
        });
        this.$root.$on('load-items11', () => {
            console.log('loadItems11 Trigger');
            let bath = localStorage.getItem('bath');
            let bed = localStorage.getItem('bed');
            let kit = localStorage.getItem('kitchen');
            let wifi = localStorage.getItem('wifi');
            let tv = localStorage.getItem('tv');
            this.loadItems('', '', '', '', '', '', '', '', '', kit, wifi, tv, bed, bath, '', '')
        });
        this.$root.$on('load-items12', () => {
            console.log('loadItems12 Trigger');
            let dic = '1';
            this.loadItems('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', dic)
        });
        this.$root.$on('load-items14', () => {
            console.log('loadItems14 Trigger');
            let dic = '2';
            this.loadItems('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', dic)
        });
        this.$root.$on('load-items13', (propertyType, sdate, edate, quantity, bed, bath, minPrice, maxPrice, child, pet) => {
            console.log('loadItems13 Trigger');
            this.loadItems('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
                propertyType,
            );
        });
        this.$root.$on('load-items15', (targetAudience) => {
            console.log('loadItems15 Trigger');
            console.log("Received load-items15 event with values:");
            console.log("Target Audience:", targetAudience);
            this.loadItems('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', targetAudience);
        });
        this.$root.$on('load-items16', (searchText) => {
            console.log('loadItems16 Trigger');
            console.log("Received load-items16 event with values:");
            console.log("search value:", searchText);
            this.$nextTick(() => {
                this.seen = true;
                let element = document.querySelector('.bottom-head');
                if (element) {
                    element.classList.remove('hidden_filter');
                }
            });
            let searchButton = document.querySelector('.search-button');
            if (searchButton) {
                searchButton.classList.remove('hidden_filter');
            }
            let mainBarElement = document.getElementById('main_bar');
            if (mainBarElement) {
                mainBarElement.style.display = "none";
            }

            this.loadItems('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', searchText);
        });
        this.$root.$on('load-items17', (city, country) => {
            console.log('loadItems17 Trigger');
            this.$nextTick(() => {
                this.seen = true;
                let element = document.querySelector('.bottom-head');
                if (element) {
                    element.classList.remove('hidden_filter');
                }
            });
            let searchButton = document.querySelector('.search-button');
            if (searchButton) {
                searchButton.classList.remove('hidden_filter');
            }
            let mainBarElement = document.getElementById('main_bar');
            if (mainBarElement) {
                mainBarElement.classList.add('hidden_filter');
            }
            this.loadItems(city, '', country, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '');
        });
        // this.fetchUserLocation();
        // this.loadItems();
        if (!this.isLoaded) {
            let searchStateStr = localStorage.getItem('searchPropertyState');
            let lastSearchedLocation = localStorage.getItem('lastSearchedLocation');
            
            if (searchStateStr) {
                try {
                    let persistedState = JSON.parse(searchStateStr);
                    this.$root.$emit('update-search-placeholder', lastSearchedLocation || '');
                    this.loadItems(
                        persistedState.city || '',
                        persistedState.country || '',
                        persistedState.state || '',
                        persistedState.startdate || '',
                        persistedState.enddate || '',
                        persistedState.guests || '',
                        persistedState.type || '',
                        persistedState.min || 1,
                        persistedState.max || 50000,
                        persistedState.kit || '',
                        persistedState.wifi || '',
                        persistedState.tv || '',
                        persistedState.bed || '',
                        persistedState.bath || '',
                        persistedState.fav || '',
                        persistedState.child || '',
                        persistedState.pet || '',
                        persistedState.dic || '',
                        persistedState.propertyType || '',
                        persistedState.targetAudience || '',
                        persistedState.searchText || '',
                        null,
                        persistedState.ratingRange || null
                    );
                    this.isLoaded = true;
                } catch (e) {
                    console.error("Error parsing searchPropertyState", e);
                }
            }
            
            if (!this.isLoaded && lastSearchedLocation) {
                let locationParts = lastSearchedLocation.split(',');
                if (locationParts.length === 3) {
                    let city = locationParts[0];
                    let state = locationParts[1];
                    let country = locationParts[2];
                    this.$root.$emit('update-search-placeholder', lastSearchedLocation);
                    this.loadItems(city, country, state, '', '', '', '', 1, 50000, '', '', '', '', '', '', '', '', '', '');
                    this.isLoaded = true;
                }
            }
            
            if (!this.isLoaded) {
                // Load all properties once with no location filter — single API call
                this.loadItems('', '', '', '', '', '', '', 1, 50000, '', '', '', '', '', '', '', '', '', '');
                this.isLoaded = true;
            }
        }


        Vue.prototype.$EventBus.$on('changeLanguage', this.onLanguageChanged);
        this.sortByRating('desc');
        // Listen for search-initiated event from SearchInput component - SINGLE listener only
        this.$root.$on('search-initiated', (payload) => {
            console.log('=== search-initiated received in Home.vue ===', payload);
            // Update local search state
            this.city = payload.city || '';
            this.regionName = payload.state || '';
            this.country = payload.country || '';
            // If navigate to results, do NOT navigate here - let SearchInput handle it
            if (!payload.navigateToResults) {
                // Load properties on Home page
                this.loadItems(
                    payload.city || '',
                    payload.country || '',
                    payload.state || '',
                    null,        // startdate
                    null,        // enddate
                    null,        // guests
                    null,        // type
                    1,           // min (default)
                    50000,       // max (default)
                    null,        // kit
                    null,        // wifi
                    null,        // tv
                    null,        // bed
                    null,        // bath
                    null,        // fav
                    null,        // child
                    null,        // pet
                    null,        // dic
                    null,        // propertyType
                    null,        // targetAudience
                    payload.searchText || '',  // searchText
                    null,        // currency
                    null         // ratingRange
                );
            }
        });
    },
    methods: {
        // handleMouseOver() {
        //     console.log('dddd');
        //     this.loadMore();
        // },

        sortByPrice(order) {
            let sortedProperties = [...this.displayedProperties];
            sortedProperties.sort((a, b) => {
                let priceA = parseFloat(a.price);
                let priceB = parseFloat(b.price);

                if (isNaN(priceA)) priceA = Infinity;
                if (isNaN(priceB)) priceB = Infinity;

                if (order === 'desc') {
                    return priceB - priceA; // Sort descending (high to low)
                } else if (order === 'asc') {
                    return priceA - priceB; // Sort ascending (low to high)
                }

                return 0;
            });

            this.displayedProperties = sortedProperties;
        },

        sortByRating(order) {
            let sortedProperties = [...this.displayedProperties];

            if (order === 'desc' || order === 'asc') {
                sortedProperties.sort((a, b) => {
                    let ratingA = this.calculateAverageRating(a.rating) || -Infinity;
                    let ratingB = this.calculateAverageRating(b.rating) || -Infinity;

                    if (order === 'desc') {
                        return ratingB - ratingA;
                    } else if (order === 'asc') {
                        return ratingA - ratingB;
                    }

                    return 0;
                });
            }

            this.displayedProperties = sortedProperties;
        },
        // fetchCurrency() {
        //     axios.get('https://ipapi.co/currency/')
        //         .then(response => {
        //             this.currency = response.data;
        //             // console.log(this.pprice.price);
        //             // console.log(this.pprice.currency);
        //             // setTimeout(() => {
        //             //     this.covertcurency(this.pprice.price, this.pprice.currency, this.currency);
        //             // }, 2000);

        //         })
        //         .catch(error => {
        //             this.currency = 'USD';
        //             console.error('Error fetching currency:', error);
        //         });
        // },

        formatLocation(property, lang = '') {
            if (!property) return '';
            const cityKey = lang ? 'city' + lang : 'city';
            const stateKey = lang ? 'state' + lang : 'state';
            const countryKey = lang ? 'country' + lang : 'country';

            const rawCity = property[cityKey] || property.city || '';
            const rawState = property[stateKey] || property.state || '';
            const rawCountry = property[countryKey] || property.country || '';

            const rawParts = [rawCity, rawState, rawCountry];
            const parts = [];
            for (const p of rawParts) {
                if (p && typeof p === 'string') {
                    const trimmed = p.trim();
                    if (trimmed && !parts.some(existing => existing.toLowerCase() === trimmed.toLowerCase())) {
                        parts.push(trimmed);
                    }
                }
            }
            return parts.join(', ');
        },

        fetchLocationDetails(ip) {
            API.getNearByProperties(ip)
            .then(response => {
                const data = response.data;

                if (!data.success) {
                throw new Error(data.message || 'Location not found');
                }

                const city = data.city || '';
                const country = data.country || '';
                const state = data.region || '';

                if (city && state && country) {

                const location = `${city},${state},${country}`;

                localStorage.setItem('lastSearchedLocation', location);

                this.$root.$emit('update-search-placeholder', location);

                this.loadItems(
                    city,
                    country,
                    state,
                    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
                );

                this.isLoaded = true;
                }
            })
            .catch(error => {
                console.error('Error fetching location:', error);
            });
        },
        fetchUserLocation() {
            fetch('https://api.ipify.org?format=json')
                .then(response => response.json())
                .then(data => {
                    const userLocation = data;
                    setTimeout(() => {
                        this.fetchLocationDetails(userLocation.ip);
                    }, 2000);
                })
                .catch(error => {
                    console.error('Error fetching IP address:', error);
                });
        },
        handleModalShown() {
            this.initializeMap();
        },
        updateSortOrder(newSortOrder) {
            this.sortOrder = newSortOrder;
        },
        initializeMap() {
            const originalUrl = this.$route.fullPath;
            let addresses = [];

            console.log('Fetching properties for map initialization');

            API.getallProperty(res => {
                res.data.data.forEach((item) => {
                    let address = `${item.city} ${item.state} ${item.country}`;
                    addresses.push(address);
                });
                const loader = new Loader({
                    apiKey: process.env.VUE_APP_GOOLE_PLACES_API_KEY,
                    version: 'weekly',
                    libraries: ['places'], // Add any additional libraries you need
                    language: 'en'
                });

                loader.load().then(() => {
                    this.map = new window.google.maps.Map(this.$refs.map, {
                        center: { lat: 0, lng: 0 },
                        zoom: 30
                    });

                    const geocoder = new window.google.maps.Geocoder();
                    const bounds = new window.google.maps.LatLngBounds();

                    addresses.forEach((address) => {
                        geocoder.geocode({ 'address': address }, (results, status) => {
                            if (status === 'OK') {
                                const marker = new window.google.maps.Marker({
                                    map: this.map,
                                    position: results[0].geometry.location
                                });
                                bounds.extend(results[0].geometry.location);
                                this.map.fitBounds(bounds);
                            } else {
                                console.error('Geocode was not successful for the following reason: ' + status);
                            }
                        });
                    });
                });
            }, err => {
                console.log(err);
            });
        },
        calculateAverageRating(ratings) {
            if (ratings.length === 0) return 0; // Return 0 if no ratings available
            const sum = ratings.reduce((total, rating) => total + rating.rating, 0);
            return (sum / ratings.length).toFixed(1); // Calculate average rating
        },
        getReviewFeedback(averageRating) {
            if (averageRating >= 4.5) {
                return "Outstanding";
            } else if (averageRating >= 3.5) {
                return "Good";
            } else if (averageRating >= 2.5) {
                return "Average";
            } else if (averageRating >= 1.5) {
                return "Below Average";
            } else {
                return "Poor";
            }
        },
        onLanguageChanged(language) {
            if (language == 'en') {
                this.currentLanguage = '';
            } else {
                this.currentLanguage = '_' + language;
            }

        },
        onSlideStart(index) {
            this.slide[index] = 0
        },
        onSlideEnd(index) {
            this.slide[index] = this.properties[index].photos.length - 1
        },
        checkIfOneMonthOrMore(startDate, endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);

            // Calculate the exact day difference
            const dayDiff = (end - start) / (1000 * 60 * 60 * 24);

            // Ensure the difference is at least 30 full days
            return dayDiff >= 30;
        },

        loadItems(city, country, state, startdate, enddate, guests, type, min, max, kit, wifi, tv, bed, bath, fav, child, pet, dic, propertyType, targetAudience, searchText, currency = null, ratingRange = null) {
             this.hasActiveFilters =
        !!city ||
        !!country ||
        !!state ||
        !!startdate ||
        !!enddate ||
        !!guests ||
        !!type ||
        !!min ||
        !!max ||
        !!kit ||
        !!wifi ||
        !!tv ||
        !!bed ||
        !!bath ||
        !!fav ||
        !!child ||
        !!pet ||
        !!dic ||
        !!propertyType ||
        !!targetAudience ||
        !!searchText ||
        !!ratingRange;
            this.activeFilterCount = [
    city,
    country,
    state,
    startdate || enddate,
    guests,
    type,
    min || max,
    kit,
    wifi,
    tv,
    bed,
    bath,
    child,
    pet,
    dic,
    propertyType,
    targetAudience,
    searchText,
    ratingRange
].filter(Boolean).length;
            this.city = city;
            this.searchedLocations = [city, state, country]
            .map(v => v?.trim())
            .filter(v => v)
            .join(', ');

            console.log('Loading items with city:', city, 'state:', state, 'country:', country);
            localStorage.setItem('lastSearchedLocation', `${city},${state},${country}`);
            targetAudience = targetAudience || '';
            let scur = localStorage.getItem('currency');
            // IP currency lookup commented out for future use:
            // if (currency) {
            //     this.currency = currency;
            //     this.fetchProperties(city, country, state, startdate, enddate, guests, type, min, max, kit, wifi, tv, bed, bath, fav, child, pet, dic, propertyType, targetAudience, searchText, this.currency, ratingRange);
            // } else if (scur) {
            //     this.currency = scur;
            // } else {
            //     axios.get('https://ipapi.co/currency/')
            //         .then(response => {
            //             this.currency = response.data;
            //         })
            //         .catch(error => {
            //             this.currency = 'AED';
            //         })
            //         .finally(() => {
            //             let selectedCurrency = this.currency;
            //             this.fetchProperties(city, country, state, startdate, enddate, guests, type, min, max, kit, wifi, tv, bed, bath, fav, child, pet, dic, propertyType, targetAudience, searchText, selectedCurrency);
            //         });
            // }
            this.currency = currency || scur || 'AED';
            this.fetchProperties(city, country, state, startdate, enddate, guests, type, min, max, kit, wifi, tv, bed, bath, fav, child, pet, dic, propertyType, targetAudience, searchText, this.currency, ratingRange);
        },
        fetchProperties(city, country, state, startdate, enddate, guests, type, min, max, kit, wifi, tv, bed, bath, fav, child, pet, dic, propertyType, targetAudience, searchText, currency, ratingRange) {
            this.isLoading = true;
            const params = {
                currency: this.currency,
                page: this.page,
            };
            this.searchedLocations = [city, state, country]
            .map(v => v?.trim())
            .filter(v => v)
            .join(', ');

            if (city) this.city = city;
            if (city) params.city = city;
            if (state) params.state = state;
            if (country) params.country = country;
            if (startdate) params.startdate = startdate;
            if (enddate) params.enddate = enddate;
            if (guests) params.guests = guests;
            if (type) params.type = type;
            if (min) params.min = min;
            if (max) params.max = max;
            if (bed) params.bed = bed;
            if (bath) params.bath = bath;
            if (kit) params.kit = kit;
            if (wifi) params.wifi = wifi;
            if (tv) params.tv = tv;
            if (fav) params.fav = fav;
            if (child) params.child = child;
            if (this.isOneMonthOrMore) params.isOneMonthOrMore = this.isOneMonthOrMore;
            if (pet) params.pet = pet
            if (dic) params.dic = dic
            if (propertyType) params.propertyType = propertyType
            if (targetAudience) params.targetAudience = targetAudience
            if (searchText) params.searchText = searchText
            if (ratingRange) params.ratingRange = ratingRange


            if(city || state || country) {
                this.locationEmpty = false;
            } else {
                this.locationEmpty = true;
            }

            API.getAllProperties(params,
                data => {
                    console.log('Fetched properties: in home.vue', data);
                    this.properties = data.data;
                    this.displayedProperties = this.properties.data;
                    this.next_page = data.data.next_page_url;
                    this.totalRecords = data.total_count;
                    if (this.totalRecords === 0 && this.hasActiveFilters && !this.loadingDefaultResults) {
                            this.loadingDefaultResults = true;
                            this.fetchProperties(
                                this.currentPage,
                                this.pageSize,
                                this.sortOrder,
                                "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""
                            );

                            return;
                        }else {
                              this.loadingDefaultResults = false;
                        }
                    // this.locationEmpty = data.locationEmpty;
                    let Authorization = localStorage.getItem('isLoggedin');
                    if (Authorization) {
                        this.addFavProperties();
                    }
                    this.isLoading = false;
                    this.isLoaded = true;
                },
                err => {
                    console.log(err);
                    this.isLoading = false;
                    this.isLoaded = true;
                }
            );
        },

        addFavProperties() {
            API.getFavProperties(
                fevData => {
                    const favoritePropertyIds = fevData.data.data.map(item => item.property_id);
                    // this.next_page = fevData.next_page_url
                    this.properties.data.forEach(property => {
                        if (favoritePropertyIds.includes(property.id)) {
                            this.$set(property, 'isFavorited', true);
                        } else {
                            this.$set(property, 'isFavorited', false);
                        }
                        this.$set(this.isDisabledProperties, property.id, false);
                    });
                }
            );
        },

        propertyDetail(id) {
            this.$router.push({ name: 'property_detail', params: { id: id } });

            // let Authorization = localStorage.getItem('isLoggedin');
            // if (Authorization) {
            //     this.$router.push({ name: 'property_detail', params: { id: id } });

            // } else {
            //     this.$router.push({ name: 'guest_login' });
            // }
        },
        loadMore() {
            this.isLoading = true;
            this.page++
            // IP currency lookup commented out for future use:
            // let currency;
            // axios.get('https://ipapi.co/currency/')
            //     .then(response => { currency = response.data; })
            //     .catch(error => { currency = 'AED'; })
            //     .finally(() => { ... });
            let currency = localStorage.getItem('currency') || this.currency || 'AED';
            const params = {
                currency: currency,
                page: this.page,
            };
            API.getAllProperties(params,
                        data => {
                            this.properties.data = [...this.properties.data, ...data.data.data];
                            this.next_page = data.data.next_page_url
                            this.isLoading = false;
                            let Authorization = localStorage.getItem('isLoggedin');
                            if (Authorization) {
                                this.addFavProperties();
                            }
                        },
                        err => {
                            console.log(err);
                            this.isLoading = false;
                        }
                    );
        },

        addFavourite(propertyId) {
            let Authorization = localStorage.getItem('isLoggedin');
            if (Authorization) {
                const property = this.properties.data.find(prop => prop.id === propertyId);
                if (property) {
                    // Disable the button while operation is in progress
                    this.$set(this.isDisabledProperties, propertyId, true);

                    API.addFavourite(propertyId, res => {
                        // this.$set(property, 'isFavorited', true);
                        if (res.data.message == 'Property deleted successfully') {
                            this.$set(property, 'isFavorited', false);
                        } else {
                            this.$set(property, 'isFavorited', true);
                        }
                        // Enable the button after operation completes (if needed)
                        this.$set(this.isDisabledProperties, propertyId, false);
                    }, err => {
                        console.log(err);
                        // Enable the button in case of error (if needed)
                        this.$set(this.isDisabledProperties, propertyId, false);
                    });
                }
            } else {
                this.$bvModal.show('modal-4');
                // this.$router.push({ name: 'guest_login' });
            }


        },
        isFavorited(property) {
            return property.isFavorited === true;
        },

        isDisabled(property) {
            // Check if the button should be disabled
            return this.isFavorited(property) || this.isDisabledProperties[property.id];
        },

        async loadPlacesService() {
            const loader = new Loader({
                apiKey: process.env.VUE_APP_GOOLE_PLACES_API_KEY,
                version: 'weekly',
                libraries: ['places'],
                language: 'en'
            });

            try {
                await loader.load();
                this.placesService = new window.google.maps.places.AutocompleteService();
            } catch (error) {
                console.error('Error loading Google Maps API:', error);
            }
        },

        handleSearchInput() {
            this.searchQuery = this.query;
            if (this.query.length < 3) {
                this.suggestions = [];
                return;
            }
            this.debouncedFetchSuggestions();
        },

        fetchSuggestions() {
            if (!this.placesService || !this.query) {
                this.suggestions = [];
                return;
            }
            this.placesService.getPlacePredictions(
                { input: this.query, types: [] },
                (predictions, status) => {
                    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                        this.suggestions = predictions || [];
                    } else if (status === window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
                        this.suggestions = [];
                    } else {
                        console.error('Error fetching place predictions:', status);
                        this.suggestions = [];
                    }
                }
            );
        },

        async selectSuggestion(suggestion) {
            if (!suggestion || !suggestion.description) return;

            const placeService = new window.google.maps.places.PlacesService(document.createElement('div'));
            placeService.getDetails({ placeId: suggestion.place_id }, (place, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    let city = '';
                    let state = '';
                    let country = '';
                    place.address_components.forEach(component => {
                        if (component.types.includes('locality')) city = component.long_name;
                        if (component.types.includes('administrative_area_level_1')) state = component.long_name;
                        if (component.types.includes('country')) country = component.long_name;
                    });
                    
                    const hasLocality = !!city;
                    const hasState = !!state;
                    const hasCountry = !!country;

                    if (!hasLocality && hasState && hasCountry) {
                        this.city = '';
                        this.regionName = state;
                        this.country = country;
                    } else if (!hasLocality && !hasState && hasCountry) {
                        this.city = '';
                        this.regionName = '';
                        this.country = country;
                    } else {
                        this.city = city || suggestion.description.split(',')[0].trim();
                        this.regionName = state || '';
                        this.country = country || suggestion.description.split(',').pop().trim();
                    }

                    this.query = suggestion.description;
                    this.searchQuery = suggestion.description;
                    this.suggestions = [];

                    console.log('Navigating with:', {
                        city: this.city,
                        state: this.regionName,
                        country: this.country,
                        query: this.query
                    });

                    // Navigate to searchProperty page WITHOUT query params
                    this.$router.push({ path: '/search-results' });
                    
                    // Emit search data after a short delay so searchProperty can mount first
                    setTimeout(() => {
                        this.$root.$emit('search-from-home', {
                            city: this.city,
                            state: this.regionName,
                            country: this.country,
                            searchText: this.query
                        });
                    }, 100);
                } else {
                    console.error('Error fetching place details:', status);
                }
            });
        },

        handleKeyUp(event) {
            if (event.key === 'Enter' && this.query) {
                this.callApiOnEnter();
            }
        },

        callApiOnEnter() {
            if (!this.query) return;
            if (this.suggestions.length > 0) {
                this.selectSuggestion(this.suggestions[0]);
            } else {
                const inputValue = this.query.toLowerCase().trim();
                const parts = inputValue.split(',').map(part => part.trim());

                let city = '';
                let state = '';
                let country = '';

                if (parts.length === 1) {
                    city = parts[0];
                } else if (parts.length === 2) {
                    city = parts[0];
                    country = parts[1];
                } else if (parts.length >= 3) {
                    city = parts[0];
                    state = parts[1];
                    country = parts[2];
                }

                this.city = city;
                this.regionName = state;
                this.country = country;
                this.searchQuery = this.query;

                console.log('Navigating (Enter pressed) with:', {
                    city: this.city,
                    state: this.regionName,
                    country: this.country,
                    query: this.query
                });

                // Navigate to searchProperty page WITHOUT query params
                this.$router.push({ path: '/search-results' });
                
                // Emit search data after a short delay so searchProperty can mount first
                // setTimeout(() => {
                    this.$root.$emit('search-from-home', {
                        city: this.city,
                        state: this.regionName,
                        country: this.country,
                        searchText: this.query
                    });
                // }, 100);
            }
        },
        clearSearch() {
            this.query = '';
            this.searchQuery = '';
            this.city = '';
            this.regionName = '';
            this.country = '';
            this.suggestions = [];
        },

        serachBusiness() {
            var miles = this.miles;
            if (miles == null || miles == '') {
                miles = null;
            }
            this.isDisabled = true
        }
    },
    created() {
        // this.fetchCurrency();
        this.$root.$on('sort-order-changed', this.updateSortOrder);
        this.loadPlacesService();
        this.debouncedFetchSuggestions = _.debounce(this.fetchSuggestions, 300);
    },
}
</script>
<style scoped>
a {
    text-decoration: none;
}

.container-fluid.page-body-wrapper.client-dashbboard {
    padding-top: 75px !important;
}

.main-heading {
    margin-bottom: 16px;
}

.main-heading h1 p {
    font-weight: 600;
    line-height: 1.2;
    font-size: 16px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
}

header {
    position: fixed;
    top: 0;
    background-color: #fff;
    box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.5);
    z-index: 1111;
}

.top-partner-item.top-partners__item.buscont {
    background: #fff;
    align-items: center;
    border-radius: 5px;
    /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px !important; */
    box-shadow: none;
}


.home-page-sec .container {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 1832px;
}

.home-page-sec .row .top-partner-item {
    flex-direction: column;
    border-radius: 12px !important;
}

.home-page-sec .row .top-partner-item .imgdet {
    width: 100%;
}

.home-page-sec .row .top-partner-item .imgdet .top-partner-item__image-wrapper {
    width: 100% !important;
    padding: 0;
}

html .home-page-sec .row .top-partner-item .imgdet .top-partner-item__image-wrapper img.buz-img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-top-left-radius: 12px !important;
    border-top-right-radius: 12px !important;
}

.home-page-sec .row .top-partner-item .imgdet .card-discription {
    padding: 10px;
}

header {
    position: fixed;
    top: 0;
    background-color: #fff;
    box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.5);
    z-index: 1111;
}

.top-partner-item.top-partners__item.buscont {
    background: #fff;
    align-items: center;
    border-radius: 5px;
    /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px !important; */
}

.hd-wrap span#RegisterDropdown {
    color: #fff !important;
    background-color: transparent !important;
    border: 2px solid #fff !important;
    font-size: 13px;
    padding: 13px 22px;
    line-height: 1;
    border-radius: 10rem;
    transition: all .2s ease-in-out;
    margin: 0;
    margin-left: 8px;
    font-weight: 400;
    box-shadow: 0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 5%);
    cursor: pointer;
}

.hd-wrap span#RegisterDropdown:hover,
.hd-wrap span#RegisterDropdown:focus {
    -webkit-box-shadow: 0 5px 11px 0 rgb(0 0 0 / 14%), 0 4px 15px 0 rgb(0 0 0 / 12%) !important;
    box-shadow: 0 5px 11px 0 rgb(0 0 0 / 14%), 0 4px 15px 0 rgb(0 0 0 / 12%) !important;
}

.hd-wrap #LoginDropdown {
    color: #fff;
    font-weight: 400;
    -webkit-transition: .35s;
    transition: .35s;
}

.hd-wrap #LoginDropdown:hover {
    color: #eee;
}

span#RegisterDropdown span {
    color: #fff !important;
}

span#LoginDropdown span {
    color: #fff !important;
    -webkit-transition: .35s;
    transition: .35s;
}

span#LoginDropdown span:hover {
    color: #eee !important;
}

html[data-scroll="0"] .logo-header a img {
    -webkit-filter: brightness(0) invert(1);
    filter: brightness(0) invert(1);
}

html:not([data-scroll="0"]) body,
html[data-scroll="0"] body {
    padding-top: 0em;
}

html:not([data-scroll="10"]) header {
    position: fixed;
    top: 0;
    background-color: #fff;
    box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.5);
    z-index: 2;
}

html:not([data-scroll="0"]) .hd-wrap span#RegisterDropdown {
    color: #42aaff !important;
    background-color: transparent !important;
    border: 2px solid #42aaff !important;
    font-size: 13px;
    padding: 13px 22px;
    line-height: 1;
    border-radius: 10rem;
    transition: all .2s ease-in-out;
    margin: 0;
    margin-left: 8px;
    font-weight: 400;
    box-shadow: 0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 5%);
    cursor: pointer;
}

html:not([data-scroll="0"]) .hd-wrap #LoginDropdown {
    color: #6c757d;
    font-weight: 400;
    -webkit-transition: .35s;
    transition: .35s;
}

html:not([data-scroll="0"]) span#RegisterDropdown span {
    color: #6c757d !important;
}

html:not([data-scroll="0"]) span#LoginDropdown span {
    color: #6c757d !important;
}

/* Ends here */

.right-bdr {
    border-right: 1px solid #efefef;
    border-right-width: 1px;
    border-right-style: solid;
    border-right-color: rgb(239, 239, 239);
    margin-bottom: 0px;
}

.gray-divider {
    width: 100%;
    height: 1px;
    background: #efefef;
}

.some-cmnt {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px !important;
    font-weight: 400 !important;
    padding-top: 15px;
    margin-bottom: 0;
    font-family: 'Roboto', sans-serif;
    line-height: 25px;

}

.listing-bg-box {
    width: 100%;
    background: #fff;
    box-shadow: none;
    border-radius: 15px;
    margin-bottom: 20px;
    padding: 20px 15px;
    display: inline-block;
}

.progress .progress-bar {
    border-radius: 30px;
    box-shadow: none;
    position: relative;
    animation: animate-positive 2s;
    background: #70d3ff !important;
}

.time-hours {
    color: #363f4d;
    font-size: 15px;
    margin-top: 8px;
    letter-spacing: 1px;
    font-weight: 700;
    display: flex;
}

.time-hours span {
    color: #363f4d;
    /* border-right: 1px solid #ccc; */
    padding-right: 5px;
    font-weight: 700;
}

.progress {
    border-radius: 50px;
}

.progress .progress-bar {
    border-radius: 0px;
}

.card-discription .rating-starts {
    margin-bottom: 4px;
    align-items: center;
    column-gap: 4px;
}

.card-discription .rating-starts .rating-counter {
    padding-left: 4px;
    padding-right: 4px;
    background-color: #e2ebfa;
    border-radius: 5px;
    font-weight: 600;
    color: #000;
}

.card-discription .rating-starts span.reviews-expretion {
    font-weight: 600;
}

.card-discription .rating-starts span {
    font-size: 15px;
}

.card-discription .rating-starts span.reviews-text {
    font-weight: 400;
    font-size: 14px;
}

.shop-inner-section .container {
    max-width: 1832px;
}

.box-footer .card-blue-btn {
    background-color: #70d3ff;
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    padding-left: 12px;
    padding-right: 12px;
    gap: 8px;
    text-decoration: none;
    min-height: 32px;
    width: 100%;
    max-width: max-content;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    text-decoration: none;
}

.box-footer .card-blue-btn:hover {
    border: 1px solid #70d3ff;
    background: #fff;
    color: #70d3ff;
}

.box-footer {
    justify-content: space-between;
    margin-top: 30px;
}

.box-footer span {
    font-weight: 600;
    font-size: 17px;
    text-transform: uppercase;
}

.box-footer span:last-child {
    text-transform: lowercase;
    font-weight: 400;
}

.box-footer span.text-xlightgrey {
    color: #c0c2c4;
    margin-right: 5px;
}

.box-footer span.tadd-date {
    font-size: 14px;
    line-height: 1.25rem;
    max-width: 170px;
    margin-left: 5px;
    text-decoration: underline;
    font-weight: 400;
}

.gap-y-xs {
    display: flex;
    align-items: center;
}

.favorite-button {
    position: absolute;
    right: .75rem;
    top: 1rem !important;
}

.favorite-button-discount {
    position: absolute;
    left: .75rem;
    top: 1rem !important;
}

.favorite-button button.heart-btn {
    border-radius: 100px;
    height: 32px;
    width: 32px;
    border: 0;
    background: #70d3ff;
    color: #fff;
    position: relative;
    z-index: 2;
    display: none;
}

.top-partner-item.top-partners__item.buscont>div.imgdet:hover .favorite-button button.heart-btn {
    display: block;
}

.checked-span {
    padding: 4px 12px;
    background-color: #70d3ff;
    color: #000;
    font-size: 15px;
    line-height: normal;
    border-radius: 6px;
    box-shadow: 0 0 6px 0px #70d3ff;
}

.b-carousel img,
.carousel .carousel-inner .carousel-item img {
    height: 350px !important;
    object-fit: cover !important;
}

.b-carousel img,
.carousel .carousel-inner .carousel-item img {
    height: 350px !important;
    object-fit: cover !important;
}

@media only screen and (max-width: 767px) {
    .box_title a p {
        font-size: 16px !important;
    }

    .buz-name {
        font-size: 20px !important;
    }

    .main-heading h1 p {
        gap: 0;
    }

    .main-heading h1 p span {
        display: block;
        width: 100%;
    }
}

@media only screen and (max-width: 575px) {
    .right-bdr {
        border-right: 0;
        border-right-width: 0;
    }
}

#home_search .pl-0 {
    padding-left: 0px;
}

#home_search .pr-0 {
    padding-right: 0px;
}

.search-bar form {
    margin-bottom: 50px;
    float: left;
    width: 100%;
    background: #fff;
    box-shadow: -2px 0px 19px 0px #cccccc;
    padding: 15px;
    border-radius: 40px;
}

.search-bar button {
    width: 100%;
    height: 50px;
    padding: 15px 37px;
    margin-left: -5px;
    background: #70d3ff;
    border: 1px solid#70d3ff;
    border-top-right-radius: 40px;
    border-bottom-right-radius: 40px;
}

.search-bar .fa-search {
    color: #fff;
}

.search-bar .fa-spinner {
    color: #fff;
}

.search-bar img {
    padding-top: 100px;
    padding-bottom: 50px;
    width: 150px;
}

.custom-srch-box {
    height: 50px;
    width: 100%;
    border: 1px solid #f9f0f0;
    border-top-left-radius: 40px;
    border-bottom-left-radius: 40px;
    padding-left: 15px;
}

#home_search select {
    height: 50px;
    width: 99%;
    border: 1px solid #f9f0f0;
    border-radius: 0px;
    padding-left: 15px;
    background: #fff;
    border-left: 0px;
    -moz-appearance: auto;
    -webkit-appearance: auto;
}

#home_search select:focus {
    outline: none;
}

.disabled {
    pointer-events: none;
}

.top-partner-item__image {
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: 100%;
    mask-size: 100%;
    z-index: 0;
    width: 120px;
}

.card-discription .rating-starts span {
    font-size: 15px;
}

.card-discription .rating-starts span.reviews-text {
    font-weight: 400;
    font-size: 13px;
}

.shop-inner-section .container {
    max-width: 1832px;
}

.box-footer {
    justify-content: space-between;
    margin-top: 20px;
}

.box-footer span {
    font-weight: 600;
}

.box-footer span.text-xlightgrey {
    color: #c0c2c4;
    color: #000;
    margin: 0;
}

.box-footer span.tadd-date {
    font-size: 14px;
    line-height: 1.25rem;
    max-width: 170px;
    margin-left: 5px;
    text-decoration: underline;
    font-weight: 400;
}

.gap-y-xs {
    display: flex;
    align-items: center;
}

.favorite-button {
    position: absolute;
    right: .75rem;
    top: 1rem !important;
}

.b-carousel img,
.carousel .carousel-inner .carousel-item img {
    height: 350px !important;
    object-fit: cover !important;
}

.box-column {
    width: 20%;
    margin-bottom: 24px;
}

.card-discription .detail-text p {
    margin: 0 !important;
    font-size: 17px;
}

/* .card-discription .detail-text {
    min-height: 42px;
} */

/* @media only screen and (max-width: 1719px) {

    .b-carousel img,
    .carousel .carousel-inner .carousel-item img {
        height: 215px !important;
        object-fit: cover !important;
    }


} */

/* @media only screen and (max-width: 1719px) {
    .box-column {
        width: 20%;
    }
} */

@media only screen and (max-width: 1399px) {
    .box-column {
        width: 25%;
    }

    .b-carousel img,
    .carousel .carousel-inner .carousel-item img {
        height: 300px !important;
    }
}

@media only screen and (max-width: 1149px) {
    .box-column {
        width: 33%;
    }
}

@media (max-width: 992px) {
    .box-column {
        width: 50%;
    }
}

@media only screen and (max-width: 767px) {
    .box_title a p {
        font-size: 16px !important;
    }

    .b-carousel img,
    .carousel .carousel-inner .carousel-item img {
        height: 250px !important;
    }
}

@media only screen and (max-width: 574px) {
    .right-bdr {
        border-right: 0;
        border-right-width: 0;
    }

    .box-column {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    .d-flex.flex-column.position-static {
        min-height: inherit;
    }
        .b-carousel img,
    .carousel .carousel-inner .carousel-item img {
        height: 250px !important;
    }
}

@media only screen and (max-width: 400px) {
    .box-column {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
}

#home_search .pl-0 {
    padding-left: 0px;
}

#home_search .pr-0 {
    padding-right: 0px;
}

.search-bar form {
    margin-bottom: 50px;
    float: left;
    width: 100%;
    background: #fff;
    box-shadow: -2px 0px 19px 0px #cccccc;
    padding: 15px;
    border-radius: 40px;
}

.search-bar button {
    width: 100%;
    height: 50px;
    padding: 15px 37px;
    margin-left: -5px;
    background: #70d3ff;
    border: 1px solid#70d3ff;
    border-top-right-radius: 40px;
    border-bottom-right-radius: 40px;
}

.search-bar .fa-search {
    color: #fff;
}

.search-bar .fa-spinner {
    color: #fff;
}

.search-bar img {
    padding-top: 100px;
    padding-bottom: 50px;
    width: 150px;
}

.custom-srch-box {
    height: 50px;
    width: 100%;
    border: 1px solid #f9f0f0;
    border-top-left-radius: 40px;
    border-bottom-left-radius: 40px;
    padding-left: 15px;
}

#home_search select {
    height: 50px;
    width: 99%;
    border: 1px solid #f9f0f0;
    border-radius: 0px;
    padding-left: 15px;
    background: #fff;
    border-left: 0px;
    -moz-appearance: auto;
    -webkit-appearance: auto;
}

#home_search select:focus {
    outline: none;
}

.disabled {
    pointer-events: none;
}


@media (min-width: 1025px) {
    .top-partner-item__image {
        width: 138px;
    }
}

.top-partner-item__image_close {
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: 100%;
    mask-size: 100%;
    z-index: 0;
    width: 120px;
}

@media (min-width: 1025px) {
    .top-partner-item__image_close {
        width: 138px;
    }
}

.buscont {
    /* display: flex; */
    /* Standard syntax */
    /* display: -webkit-flex; */
    /* Safari */
    margin-bottom: 24px;
    box-shadow: 0px 0px 8px 1px rgb(212 212 212 / 39%);
    padding: 8px !important;
    border-radius: 12px;
    padding-bottom: 24px !important;
}

.buscont:hover {
    cursor: pointer;
}

.imgdet {
    -webkit-flex: 1;
    /* Safari */
    -ms-flex: 1;
    /* IE 10 */
    flex: 1;
    /* Standard syntax */
}

.top-partner-item__image-wrapper {
    position: relative;
    text-align: center;
}

.buz-name {
    background: #fff;
    border-radius: 0px;
    font-size: 25px;
    font-weight: 700;
    color: #333333;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 250px;
    margin-bottom: 0px !important;
}

.buz-time {
    color: #fff;
    font-size: 16px;
    font-weight: 300;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #444141b0;
    padding: 2px 15px;
    border-radius: 5px;
}

.buz-timing {
    font-size: 12px;
    font-weight: 500;
    font-family: 'Poppins';
    position: absolute;
    bottom: 16px;
    right: 15px;
    border-top: 1px solid #efefef;
    background: #4ebaff;
    padding: 5px;
    color: white !important;
    border-top-left-radius: 5px;
}

.closeclass {
    filter: opacity(0.5);
}

/* img.buz-img{
        border-radius: 7px !important;
        width: 200px;
        height: 150px;
        margin: 10px;
        object-fit: fill;
        -webkit-box-shadow: 0 5px 11px 0 rgba(0,0,0,.18),0 4px 15px 0 rgba(0,0,0,.15)!important;
        box-shadow: 0 5px 11px 0 rgba(0,0,0,.18),0 4px 15px 0 rgba(0,0,0,.15)!important;
    } */
img.buz-img {
    /* border-radius: 7px !important; */
    width: 100%;
    height: 150px;
    margin: 10px;
    object-fit: fill;
    /* -webkit-box-shadow: 0 5px 11px 0 rgba(0,0,0,.18),0 4px 15px 0 rgba(0,0,0,.15)!important;
        box-shadow: 0 5px 11px 0 rgba(0,0,0,.18),0 4px 15px 0 rgba(0,0,0,.15)!important; */
    box-shadow: none;
    border: 1px solid #ddd;
    border-radius: 0;
}

.left-card {
    border-right: none !important;
}

@media (min-width: 768px) and (max-width: 991px) {

    .mobile-responsive .center-tabs-layout,
    .hidden-bar {
        display: none;
    }

    .top-partner-item__image-wrapper {
        width: 123px !important;
        height: 95px !important;
    }

    img.buz-img {
        width: 100px;
        height: 75px;
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .top-partner-item__image-wrapper {
            width: 123px !important;
            height: 95px !important;
        }

        img.buz-img {
            width: 100%;
            height: 75px;
        }

        .buz-time[data-v-b0b0db8e] {
            font-size: 12px;
        }

        .buscont[data-v-b0b0db8e] {
            min-height: 200px;
        }
    }

    .buscont[data-v-b0b0db8e] {
        min-height: 200px;
    }
}

@media (max-width: 991px) {
    .pt_large {
        padding-top: 110px !important;
    }
}

@media (min-width: 992px) {
    .pt_large {
        padding-top: 110px !important;
    }
}

.top-partner-item.top-partners__item.buscont img.buz-img {
    margin: 0px;
    border: 0px !important;
    box-shadow: none !important;
    height: 170px;
    object-fit: cover;
    border-radius: 0px !important;
}

.top-partner-item.top-partners__item.buscont:hover {
    /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
    /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px !important;
    border: 1px solid transparent !important; */
}

.pt_large.pb_large.shop-inner-section {
    background: #fff;
    padding-top: 0 !important;
}

.top-partner-item.top-partners__item.buscont {
    padding: 0px !important;
    border-radius: 30px;
    overflow: hidden;
    position: relative;
    border: 1px solid #D9D9D9;
    height: 100%;
    margin: 0;
}

.top-partner-item.top-partners__item.buscont>div.imgdet {
    flex: unset;
}


.top-partner-item__image-wrapper {
    padding-bottom: 35px;
}

.shop-inner-section .page-banner {
    margin-bottom: 50px;
    /* background-image: url(https://paseomarket.com/storage/users/cover_image/sQ7LyPD3SuXgAdQWdybHtNzJhFZzEgELhRScw8DR.jpg); */
    background-image: url(/images/hero-bg.png?156791b69b3ea459aefaeb2e1ccc3ac6);
    height: 200px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: 50%;
    position: relative;
    z-index: 1;
}

.shop-inner-section .page-banner i {
    right: 13px;
    position: absolute;
    color: #fff;
    top: 10px;
    cursor: pointer;
}

.shop-inner-section .page-banner .banner_content {
    /* padding: 50px 0px;
        text-align: center;
        background-color: #4ebaff; */
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.shop-inner-section .page-banner .banner_content:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: #0000001c;
    top: 0;
    left: 0;
    z-index: -1;
}

.shop-inner-section .page-banner .banner_content h2 {
    color: #fff;
    text-align: center;
    letter-spacing: 5px;
    text-shadow: 2px 7px 5px rgba(0, 0, 0, 0.3),
        0px -4px 10px rgba(255, 255, 255, 0.3);
}

@media (min-width: 1024px) {
    .top-partner-item__image-wrapper {
        padding-bottom: 0px;
    }
}

@media (min-width: 500px) and (max-width: 767px) {
    .top-partner-item__image-wrapper {
        padding-bottom: 0px;
    }
}

/* .top-partner-item.top-partners__item.buscont>div.imgdet:nth-child(2) {
    height: calc(50% - 12px);
} */

.d-flex.flex-column.position-static {
    padding: 20px;
    height: 100%;
    justify-content: space-around;
    /* min-height: 191px; */
}

.float-left {
    float: none !important;
}

@media (max-width:991px) {
    .top-partner-item.top-partners__item.buscont>div.imgdet {
        width: 50%;
    }

    .top-partner-item.top-partners__item.buscont {
        border-radius: 20px;
    }

    .top-partner-item__image-wrapper {
        width: 100% !important;
    }
}

@media (max-width: 1023px) {
    .top-partner-item__image-wrapper {
        padding-bottom: 0;
    }

    .card-discription .card-text {
        font-size: 12px;
    }

    .d-flex.flex-column.position-static {
        padding-bottom: 15px;
    }

    .top-partner-item__image-wrapper {
        height: inherit !important;
    }
}

@media (max-width: 768px) {
    .shop-inner-section .page-banner .banner_content {
        padding: 20px 0px;
    }
}

@media (max-width: 574.98px) {
    .top-partner-item.top-partners__item.buscont {
        flex-wrap: wrap;
    }
}

@media (max-width:991px) {

    .top-partner-item__image-wrapper {
        width: 100% !important;
        padding-right: 0;
    }

    .top-partner-item.top-partners__item.buscont>div.imgdet,
    img.buz-img {
        width: 100%;
    }


    .d-flex.flex-column.position-static {
        padding: 15px 10px;
    }
}
</style>
<style scoped>
.google-places-autocomplete {
    position: relative;
}

#autocomplete {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
}

.suggestions-list {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    border: 1px solid #ddd;
    background: white;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.suggestions-list li {
    padding: 8px;
    cursor: pointer;
}

.suggestions-list li:hover {
    background-color: #f0f0f0;
}


.strikethrough {
    text-decoration: line-through;
    display: none;
}

.favorite-button-discount span.checked-span {
    box-shadow: 0 0 0 0;
    border-radius: 100px;
    height: 32px;
    width: max-content;
    border: 0;
    background: #70d3ff;
    color: #fff;
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
}

.new-heart-btn {
    background-color: transparent;
    border: none;
    outline: none;
    color: #000;
}

.skeleton-card {
    width: 100%;
    height: 250px;
    background: #f3f3f3;
    border-radius: 10px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    animation: pulse 1.5s infinite;
}

.skeleton-img {
    width: 100%;
    height: 150px;
    background: #e0e0e0;
    border-radius: 8px;
}

.skeleton-text {
    width: 80%;
    height: 15px;
    background: #d0d0d0;
    border-radius: 4px;
    margin-top: 10px;
}

.skeleton-text.small {
    width: 60%;
}

.skeleton-text.large {
    height: 1em;
    min-width: 150px;
    /* Ensures a reasonable default */
    max-width: 250px;
    /* Prevents it from stretching too much */
    background: #e0e0e0;
    border-radius: 4px;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        background-color: #e0e0e0;
    }

    50% {
        background-color: #f5f5f5;
    }

    100% {
        background-color: #e0e0e0;
    }
}

.box-footer .card-blue-btn.new-button {
    background-color: #70d3ff3d;
    color: #000;
    font-weight: 600;
    font-size: 16px;
    transition: all 0.2s ease-in;
}
.box-footer .card-blue-btn.new-button:hover {
    background-color: #70d3ff;
    border: 0px;
}


@media (max-width: 575px) {
    .new-shop-section .top-partner-item.top-partners__item.buscont>div.imgdet {
       width: auto;
        flex: 1;
    }
    .new-shop-section .top-partner-item.top-partners__item.buscont>div.imgdet.position-relative {
        max-width: 140px;
        border-radius: 30px;
        overflow: hidden;
                min-width: 140px;
    }
    .new-shop-section .box-footer span, .new-shop-section .card-discription .card-text span {
      font-size: 14px;
    }
    .new-shop-section .card-discription .card-text span {
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: unset;
        max-width: unset;
    }
    .shop-inner-section.new-shop-section .top-partner-item.skeleton-card {
        display: flex !important;
        flex-direction: row;
        gap: 20px;
    }
    .shop-inner-section.new-shop-section .top-partner-item.skeleton-card > div {
        width: 50%;
    }
}
</style>
